import { render } from "./MessagesList.vue?vue&type=template&id=dd34b198"
import script from "./MessagesList.vue?vue&type=script&lang=js"
export * from "./MessagesList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__